import type { IntegrationFactory } from './factory';

export const gtmFactory: IntegrationFactory = async (config, global, ctx) => {
  const containerId = config.getOrThrow('GTM_ID') as unknown as string;
  const { GoogleTagManager } = await import('@cp/shared/tracking/integrations/google-tag-manager');
  return new GoogleTagManager(
    {
      containerId,
    },
    global,
    ctx,
  );
};
